export { default } from "./Dropzone";
